<template>
	<div class="g-block-pay-image-wall" :class="{
		'g-block-pay-image-wall--edit': editable,
		'is-active': editable && active,
		'g-block-pay-image-wall--h5': h5,
		'g-block-pay-image-wall--unlocked': isUnlocked,
	}" :style="rootStyle" @click="onWrapClick">
		<div class="g-block-pay-image-wall__card">
			<div class="g-block-pay-image-wall__header">
				<div class="g-block-pay-image-wall__cover">
					<img v-if="coverUrl" :src="coverUrl" alt="" />
					<i v-else class="mbm-iconfont mbm-tupian"></i>
					<span class="g-block-pay-image-wall__cover-badge">{{ totalCount }}张</span>
				</div>
				<div class="g-block-pay-image-wall__header-body">
					<div class="g-block-pay-image-wall__header-info">
						<div class="g-block-pay-image-wall__header-info-row">
							<div class="g-block-pay-image-wall__title">{{ wallData.title }}</div>
							<div v-if="!isUnlocked && !shouldHidePrice" class="g-block-pay-image-wall__price">
								<span class="g-block-pay-image-wall__currency">{{ wallData.currency }}</span>
								<span class="g-block-pay-image-wall__price-value">{{ wallData.price }}</span>
							</div>
						</div>
						<div class="g-block-pay-image-wall__header-info-row">
							<div class="g-block-pay-image-wall__subtitle">{{ subtitleText }}</div>
							<button v-if="!isUnlocked && !shouldHidePrice" type="button"
								class="g-block-pay-image-wall__unlock-btn" :style="buttonStyle"
								@click.stop="onUnlockClick">{{ wallData.buttonText }}</button>
						</div>
					</div>
					<div class="g-block-pay-image-wall__features">
						<span v-for="feature in wallData.features" :key="feature.id"
							class="g-block-pay-image-wall__feature">
							<i class="g-block-pay-image-wall__feature-icon" :class="featureIconClass(feature.icon)"></i>
							<span>{{ feature.text }}</span>
						</span>
					</div>
				</div>
			</div>
			<!-- <div v-if="!isUnlocked && showInfoBar" class="g-block-pay-image-wall__info">
				<SoundOutlined class="g-block-pay-image-wall__info-icon" />
				<span>
					解锁后可查看全部
					<strong>{{ totalCount }}</strong>
					张图片
				</span>
			</div> -->
			<div class="g-block-pay-image-wall__list">
				<div v-for="entry in listEntries" :key="entry.key" class="g-block-pay-image-wall__item">
					<div class="g-block-pay-image-wall__thumb" :class="{
						'is-locked': entry.locked,
						'is-previewable': isItemPreviewable(entry.index),
					}" :style="thumbStyle" @click="onThumbClick(entry.index, $event)">
						<img v-if="getItemImageUrl(entry.item)" :src="getItemImageUrl(entry.item)" alt="" />
						<i v-else class="mbm-iconfont mbm-tupian"></i>
						<span class="g-block-pay-image-wall__index">{{ formatIndex(entry.index) }}</span>
						<div v-if="!entry.locked && getItemImageUrl(entry.item) && !isUnlocked"
							class="g-block-pay-image-wall__item-footer">
							<span class="g-block-pay-image-wall__free-tag">免费可查看</span>
						</div>
						<div v-if="entry.locked" class="g-block-pay-image-wall__lock-mask">
							<i class="mbm-iconfont mbm-suoding g-block-pay-image-wall__lock-icon"></i>
							<!-- <span class="g-block-pay-image-wall__lock-text">解锁后可查看</span> -->
						</div>
					</div>
				</div>
			</div>
		</div>
		<ImageGalleryLightbox v-model:visible="lightboxVisible" :urls="lightboxUrls" :initial-index="lightboxIndex" />
	</div>
</template>
<script>
import { geditPayUnlockMixin } from '../../../mixins/geditPayUnlock.js';
import ImageGalleryLightbox from '../../../components/ImageGalleryLightbox.vue';
import { SoundOutlined } from '@ant-design/icons-vue';
import {
	getPayImageWallGalleryUrls,
	getPayImageWallImageUrl,
	getPayImageWallListEntries,
	getPayImageWallListStyle,
	isPayImageWallUnlocked,
	normalizePayImageWallData,
	setPayImageWallUnlocked,
} from '../../../utils/payImageWall.js';
export default {
	name: 'GPayImageWallShell',
	mixins: [geditPayUnlockMixin],
	components: { ImageGalleryLightbox, SoundOutlined },
	props: {
		data: {
			type: Object,
			required: true,
		},
		blockId: {
			type: String,
			default: '',
		},
		editable: {
			type: Boolean,
			default: false,
		},
		active: {
			type: Boolean,
			default: false,
		},
		h5: {
			type: Boolean,
			default: false,
		},
	},
	emits: ['select'],
	data() {
		return {
			unlockedLocal: false,
			lightboxVisible: false,
			lightboxIndex: 0,
		};
	},
	computed: {
		wallData() {
			return normalizePayImageWallData(this.data);
		},
		listStyle() {
			return getPayImageWallListStyle(this.wallData, { h5: this.h5 });
		},
		rootStyle() {
			return {
				'--pay-wall-item-gap': this.listStyle.itemGap,
				'--pay-wall-radius': this.listStyle.borderRadius,
			};
		},
		thumbStyle() {
			if (this.fluidListLayout) {
				return {
					borderRadius: this.listStyle.borderRadius,
				};
			}
			return {
				height: this.listStyle.itemHeight,
				borderRadius: this.listStyle.borderRadius,
			};
		},
		buttonStyle() {
			return {
				background: this.wallData.buttonBg,
			};
		},
		coverUrl() {
			const first = this.wallData.items[0];
			return this.getItemImageUrl(first);
		},
		totalCount() {
			return this.wallData.items.length;
		},
		freePreviewCount() {
			return Math.min(this.wallData.freePreviewCount, this.totalCount);
		},
		subtitleText() {
			const subtitle = this.wallData.subtitle || '';
			if (/\d+/.test(subtitle)) {
				return subtitle.replace(/\d+/, String(this.totalCount));
			}
			return `共 ${this.totalCount} 张精选高清壁纸`;
		},
		isUnlocked() {
			if (this.editable) return false;
			return this.unlockedLocal || isPayImageWallUnlocked(this.blockId) || this.isGeditModulePaid;
		},
		showInfoBar() {
			return this.freePreviewCount > 0 && this.freePreviewCount < this.totalCount;
		},
		lightboxUrls() {
			if (this.isUnlocked) {
				return getPayImageWallGalleryUrls(this.wallData);
			}
			return getPayImageWallGalleryUrls(this.wallData).slice(0, this.freePreviewCount);
		},
		listEntries() {
			return getPayImageWallListEntries(this.wallData, { unlocked: this.isUnlocked });
		},
		fluidListLayout() {
			return this.editable || this.h5;
		},
	},
	watch: {
		blockId: {
			immediate: true,
			handler() {
				this.syncUnlockState();
			},
		},
	},
	methods: {
		syncUnlockState() {
			this.unlockedLocal = isPayImageWallUnlocked(this.blockId);
		},
		getItemImageUrl(item) {
			return getPayImageWallImageUrl(item?.image);
		},
		formatIndex(index) {
			return String(index + 1).padStart(2, '0');
		},
		featureIconClass(icon) {
			const map = {
				check: 'mbm-iconfont mbm-check is-check',
				download: 'mbm-iconfont mbm-xiazai1 is-download',
				shield: 'mbm-iconfont mbm-anquan is-shield',
			};
			return map[icon] || map.check;
		},
		isItemPreviewable(index) {
			if (this.editable) return false;
			if (this.isUnlocked) return Boolean(this.getItemImageUrl(this.wallData.items[index]));
			return index < this.freePreviewCount && Boolean(this.getItemImageUrl(this.wallData.items[index]));
		},
		onWrapClick() {
			if (this.editable) {
				this.$emit('select');
			}
		},
		onUnlockClick() {
			this.runGeditUnlockFlow({
				applyUnlock: () => {
					setPayImageWallUnlocked(this.blockId, true);
					this.unlockedLocal = true;
				},
			});
		},
		onThumbClick(index, event) {
			if (this.listEntries[index].locked) {
				this.onUnlockClick();
				return
			}
			if (!this.isItemPreviewable(index)) return;
			event.stopPropagation();
			this.lightboxIndex = index;
			this.lightboxVisible = true;
		},
	},
};
</script>
<style scoped lang="less">
.g-block-pay-image-wall {
	box-sizing: border-box;

	&--edit,
	&--h5 {
		width: 100%;
	}

	&--edit {
		border: 1px solid transparent;
		border-radius: 4px;
		transition: border-color 0.2s, box-shadow 0.2s;
		cursor: pointer;

		&.is-active {
			border-color: #285af9;
			box-shadow: 0 0 0 1px rgba(40, 90, 249, 0.15);
		}
	}
}

.g-block-pay-image-wall__card {
	background: #fff;
	border-radius: 12px;
	overflow: hidden;
	box-shadow: 0 0 12px rgba(0, 0, 0, 0.1);
}

.g-block-pay-image-wall__header {
	display: flex;
	align-items: stretch;
	gap: 12px;
	padding: 14px 10px 10px;
}

.g-block-pay-image-wall__cover {
	position: relative;
	flex-shrink: 0;
	align-self: flex-start;
	width: 80px;
	height: 80px;
	border-radius: 10px;
	overflow: hidden;
	background: #f5f5f5;

	img {
		display: block;
		width: 100%;
		height: 100%;
		object-fit: cover;
	}

	.mbm-tupian {
		display: flex;
		align-items: center;
		justify-content: center;
		width: 100%;
		height: 100%;
		font-size: 24px;
		color: #ccc;
	}
}

.g-block-pay-image-wall__cover-badge {
	position: absolute;
	top: 4px;
	right: 4px;
	padding: 1px 5px;
	border-radius: 4px;
	background: rgba(40, 90, 249, 0.85);
	color: #fff;
	font-size: 10px;
	line-height: 1.4;
	white-space: nowrap;
}

.g-block-pay-image-wall__header-body {
	flex: 1;
	min-width: 0;
	display: flex;
	flex-direction: column;
	gap: 8px;
}

.g-block-pay-image-wall__header-info {
	display: flex;
	flex-direction: column;
	gap: 4px;
}

.g-block-pay-image-wall__header-info-row {
	display: flex;
	align-items: center;
	justify-content: space-between;
	gap: 8px;
}

.g-block-pay-image-wall__title {
	flex: 1;
	min-width: 0;
	font-size: 18px;
	font-weight: 700;
	color: #1a1a1a;
	line-height: 1.35;
}

.g-block-pay-image-wall__subtitle {
	flex: 1;
	min-width: 0;
	font-size: 13px;
	color: #999;
	line-height: 1.4;
}

.g-block-pay-image-wall__features {
	display: flex;
	flex-wrap: nowrap;
	gap: 12px;
}

.g-block-pay-image-wall__feature {
	display: inline-flex;
	align-items: center;
	gap: 4px;
	font-size: 12px;
	color: #666;
	line-height: 1.2;
	white-space: nowrap;
	flex-shrink: 0;
}

.g-block-pay-image-wall__feature-icon {
	font-size: 12px;

	&.is-check {
		color: #52c41a;
	}

	&.is-download {
		color: #285af9;
	}

	&.is-shield {
		color: #faad14;
	}
}

.g-block-pay-image-wall__price {
	flex-shrink: 0;
	display: flex;
	align-items: baseline;
	color: #ff4d4f;
	line-height: 1;
}

.g-block-pay-image-wall__currency {
	font-size: 14px;
	font-weight: 600;
	margin-right: 2px;
}

.g-block-pay-image-wall__price-value {
	font-size: 22px;
	font-weight: 700;
}

.g-block-pay-image-wall__unlock-btn {
	flex-shrink: 0;
	border: none;
	border-radius: 999px;
	padding: 5px 14px;
	font-size: 11px;
	font-weight: normal;
	color: #fff;
	cursor: pointer;
	white-space: nowrap;
	line-height: 1.3;

	&:active {
		opacity: 0.9;
	}
}

.g-block-pay-image-wall__info {
	display: flex;
	align-items: center;
	gap: 6px;
	margin: 0 8px 12px;
	padding: 8px 10px;
	background: #fff0f0;
	border-radius: 8px;
	font-size: 12px;
	color: #666;
	line-height: 1.5;

	strong {
		color: #ff4d4f;
		font-weight: 600;
	}
}

.g-block-pay-image-wall__info-icon {
	flex-shrink: 0;
	font-size: 14px;
	color: #ff4d4f;
}

.g-block-pay-image-wall__list {
	display: flex;
	flex-direction: column;
	gap: var(--pay-wall-item-gap, 10px);
	padding: 0 8px 14px;
}

.g-block-pay-image-wall__item {
	width: 100%;
}

.g-block-pay-image-wall__thumb {
	position: relative;
	width: 100%;
	overflow: hidden;
	background: #f5f5f5;

	img {
		display: block;
		width: 100%;
		height: 100%;
		object-fit: cover;
	}

	.mbm-tupian {
		position: absolute;
		inset: 0;
		display: flex;
		align-items: center;
		justify-content: center;
		font-size: 28px;
		color: #ccc;
	}

	&.is-previewable {
		cursor: pointer;
	}
}

.g-block-pay-image-wall__index {
	position: absolute;
	top: 8px;
	left: 8px;
	z-index: 2;
	min-width: 24px;
	padding: 2px 6px;
	border-radius: 4px;
	background: rgba(255, 255, 255, 0.92);
	color: #285af9;
	font-size: 12px;
	font-weight: 600;
	line-height: 1.3;
	text-align: center;
}

.g-block-pay-image-wall__item-footer {
	position: absolute;
	left: 0;
	right: 0;
	bottom: 0;
	z-index: 2;
	display: flex;
	align-items: center;
	justify-content: flex-end;
	padding: 28px 12px 10px;
	background: linear-gradient(180deg, rgba(0, 0, 0, 0) 0%, rgba(0, 0, 0, 0.55) 100%);
}

.g-block-pay-image-wall__free-tag {
	flex-shrink: 0;
	padding: 2px 8px;
	border-radius: 999px;
	background: #52c41a;
	color: #fff;
	font-size: 10px;
	line-height: 1.4;
	white-space: nowrap;
}

.g-block-pay-image-wall__lock-mask {
	position: absolute;
	inset: 0;
	z-index: 3;
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: center;
	gap: 4px;
	background: rgba(0, 0, 0, 0.15);
}

.g-block-pay-image-wall__lock-icon {
	font-size: 20px;
	color: #fff;
}

.g-block-pay-image-wall__lock-text {
	font-size: 9px;
	color: #fff;
	text-shadow: 0 1px 2px rgba(0, 0, 0, 0.3);
}

.g-block-pay-image-wall__thumb.is-locked img {
	filter: blur(8px);
	transform: scale(1.06);
}

.g-block-pay-image-wall--unlocked {
	.g-block-pay-image-wall__item-footer {
		background: linear-gradient(180deg, rgba(0, 0, 0, 0) 0%, rgba(0, 0, 0, 0.45) 100%);
	}
}

.g-block-pay-image-wall--edit,
.g-block-pay-image-wall--h5 {


	.g-block-pay-image-wall__thumb {
		height: auto;

		img {
			height: auto;
			object-fit: contain;
		}

		.mbm-tupian {
			position: relative;
			inset: auto;
			min-height: 120px;
		}
	}
}

.g-block-pay-image-wall--h5 {
	.g-block-pay-image-wall__card {
		border-radius: 0.24rem;
		box-shadow: 0 0 0.24rem rgba(0, 0, 0, 0.1);
	}

	.g-block-pay-image-wall__header {
		gap: 0.24rem;
		padding: 0.28rem 0.2rem 0.2rem;
	}

	.g-block-pay-image-wall__cover {
		width: 1.6rem;
		height: 1.6rem;
		border-radius: 0.2rem;
	}

	.g-block-pay-image-wall__cover-badge {
		top: 0.08rem;
		right: 0.08rem;
		padding: 0.02rem 0.1rem;
		border-radius: 0.08rem;
		font-size: 0.2rem;
	}

	.g-block-pay-image-wall__header-body {
		gap: 0.16rem;
	}

	.g-block-pay-image-wall__header-info {
		gap: 0.08rem;
	}

	.g-block-pay-image-wall__header-info-row {
		gap: 0.16rem;
	}

	.g-block-pay-image-wall__title {
		font-size: 0.36rem;
	}

	.g-block-pay-image-wall__subtitle {
		font-size: 0.26rem;
	}

	.g-block-pay-image-wall__features {
		gap: 0.24rem;
	}

	.g-block-pay-image-wall__feature {
		gap: 0.08rem;
		font-size: 0.24rem;
	}

	.g-block-pay-image-wall__feature-icon {
		font-size: 0.24rem;
	}

	.g-block-pay-image-wall__currency {
		font-size: 0.26rem;
	}

	.g-block-pay-image-wall__price-value {
		font-size: 0.4rem;
	}

	.g-block-pay-image-wall__unlock-btn {
		padding: 0.1rem 0.28rem;
		font-size: 0.22rem;
	}

	.g-block-pay-image-wall__info {
		gap: 0.12rem;
		margin: 0 0.16rem 0.24rem;
		padding: 0.16rem 0.2rem;
		border-radius: 0.16rem;
		font-size: 0.24rem;
	}

	.g-block-pay-image-wall__info-icon {
		font-size: 0.28rem;
	}

	.g-block-pay-image-wall__list {
		padding: 0 0.16 0.28rem;
	}

	.g-block-pay-image-wall__thumb .mbm-tupian {
		min-height: 2.4rem;
	}

	.g-block-pay-image-wall__index {
		top: 0.16rem;
		left: 0.16rem;
		min-width: 0.48rem;
		padding: 0.04rem 0.12rem;
		border-radius: 0.08rem;
		font-size: 0.24rem;
	}

	.g-block-pay-image-wall__item-footer {
		padding: 0.56rem 0.24rem 0.2rem;
	}

	.g-block-pay-image-wall__free-tag {
		padding: 0.04rem 0.16rem;
		font-size: 0.2rem;
	}

	.g-block-pay-image-wall__lock-icon {
		font-size: 0.4rem;
	}

	.g-block-pay-image-wall__lock-text {
		font-size: 0.18rem;
	}

	.g-block-pay-image-wall__lock-mask {
		gap: 0.08rem;
	}
}
</style>
